import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Box, Link } from '@material-ui/core';
import logo from '../../images/Logo-Moovejob.png';
import connexion from '../../images/connection_background.jpg';
import theme from '../theme';

const useStyles = makeStyles((thm) => ({
  homeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: 'calc(100vh - 20px)',
    position: 'relative',
    paddingBottom: '50px',
    '& h1': {
      marginBottom: '3vh',
    },
    '& p': {
      lineHeight: '2',
      fontSize: '1.3rem',
      [thm.breakpoints.down('sm')]: {
        lineHeight: '1.5',
      },
    },
    [thm.breakpoints.down('lg')]: {
      top: '10vh',
    },
    [thm.breakpoints.down('sm')]: {
      top: '15vh',
    },
  },
  flexHeightDesktop: {
    height: 'auto',
    justifyContent: 'center',
    padding: '10vh 0',
    [thm.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  flexAround: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    textAlign: 'center',
    width: '80%',
    [thm.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  bgHero: {
    position: 'relative',
    backgroundImage: `url(${connexion})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '100vh',
    backgroundPosition: 'center',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255, 0.7)',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
  },

  alignCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoStyle: {
    maxWidth: '200px',
    margin: '0 auto',
  },
  logoStyleSmall: {
    maxWidth: '150px',
  },

  subTitle: {
    fontWeight: 'bold',
    margin: '3vh 0 6vh',
    textAlign: 'center',
    width: '100%',
  },
  linkStyle: {
    cursor: 'pointer',
  },
  buttonStyle: {
    margin: '2vh 0',
    [thm.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  html: {
    height: '100%',
    margin: 0,
    boxSizing: 'border-box',
    scrollBehavior: 'smooth',
  },
}));

const ConfimationMessage = (props) => {
  const history = useHistory();

  function navigate(path) {
    history.push(path);
  }

  const userData = props['location']['state'];

  const classes = useStyles(theme);

  return (
    <main>
      <div className={classes.bgHero}>
        <Container maxWidth={false} className={classes.homeContainer}>
          <Box>
            <Typography variant="h1" color="secondary">
              Bonjour
              {(userData) ? ` ${userData.first_name},` : ','}
            </Typography>
            <Typography variant="body2">
              Nous vous avons envoyé un message à votre adresse courriel afin de changer
              votre mot de passe .
            </Typography>
            <Typography variant="body2">
              Veuillez vérifier votre boîte courriel et modifier votre mot de passe afin de
              pouvoir vous connecter à nouveau sur
            </Typography>
            <img src={logo} alt="logo" className={classes.logoStyle}/>

            <Typography variant="body2">
              Vos données sont en sécurité avec nous.
            </Typography>
            <Typography variant="body2">
              Vous pouvez vérifier notre{' '}
              <Link onClick={() => navigate('/politique-de-confidentialite')}
                    className={classes.linkStyle}>
                <strong>politique de confidentialité.</strong>
              </Link>
            </Typography>
            <Typography variant="body2" className={classes.alignCenter}>
              l'équipe de{' '}
              <img src={logo} alt="logo" className={classes.logoStyleSmall}/>
            </Typography>
          </Box>
        </Container>
      </div>
    </main>
  );
};

export default ConfimationMessage;
